var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.13,11.67A4.62,4.62,0,1,0,5.51,7.05,4.62,4.62,0,0,0,10.13,11.67Zm0-7A2.42,2.42,0,1,1,7.71,7.05,2.43,2.43,0,0,1,10.13,4.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9,15.41H18.48V13a1.1,1.1,0,0,0-2.2,0v2.42H13.86a1.1,1.1,0,0,0,0,2.2h2.42V20a1.1,1.1,0,0,0,2.2,0V17.61H20.9a1.1,1.1,0,0,0,0-2.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2,21.13v.44H4.2v-.44a5.94,5.94,0,0,1,5.93-5.94,5.57,5.57,0,0,1,1.36.17l.58-2.12A7.76,7.76,0,0,0,10.13,13,8.15,8.15,0,0,0,2,21.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.e7526ce14d9a9d859262e12c99a4dc80.svg";
export { ForwardRef as ReactComponent };